import { withMeta } from '@/helpers/dataLayer';
import multiselect from './multiselect.vue';

export default {
  components: {
    multiselect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    required: Boolean,
    placeholder: String,
    label: {
      type: String,
      required: true,
    },
    trackBy: {
      type: String,
      required: true,
    },
    modelValue: [String, Object],
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
      default: 200,
    },
    customLabel: {
      type: Function,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    showNoResults: {
      type: Boolean,
      default: false,
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: '',
    },
    adjust: {
      type: Boolean,
      default: true,
    },
    autofillAssist: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'close', 'select', 'update:modelValue'],
  computed: {
    selectModifiers() {
      return {
        'select--has-value': this.modelValue,
        'select--small': this.small,
      };
    },
    gtmObject() {
      const [category, label] = this.gtm.split(',');
      return {
        event: 'eventTrackerTrigger',
        category,
        action: 'select',
        label,
      };
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e);
      this.$emit('update:modelValue', e);
      if (this.gtm && this.modelValue) {
        this.$gtm.trackEvent(withMeta(this.gtmObject));
      }
    },
  },
};
